import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const items = [
  "Tax Strategy",
  "Virtual Bookkeeping",
  "Business Consulting",
  "Real Estate",
  "Healthcare",
  "Technology & SaaS",
  "Professional Services",
  "State Compliance",
];

const MarqueeSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x1 = useTransform(scrollYProgress, [0, 1], ["0%", "-15%"]);
  const x2 = useTransform(scrollYProgress, [0, 1], ["-15%", "0%"]);

  return (
    <section
      ref={ref}
      className="py-16 md:py-24 bg-[#1C1917] overflow-hidden relative"
      data-testid="marquee-section"
    >
      <motion.div style={{ x: x1 }} className="flex whitespace-nowrap gap-16 mb-8">
        {[...items, ...items].map((item, i) => (
          <div key={`row1-${i}`} className="flex items-center gap-16">
            <span className="font-heading text-3xl md:text-4xl lg:text-5xl font-light italic text-[#F9F8F6]">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#C85A43] flex-shrink-0" />
          </div>
        ))}
      </motion.div>

      <motion.div style={{ x: x2 }} className="flex whitespace-nowrap gap-16">
        {[...items.slice().reverse(), ...items.slice().reverse()].map((item, i) => (
          <div key={`row2-${i}`} className="flex items-center gap-16">
            <span className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-[#F9F8F6]/25 tracking-tight">
              {item}
            </span>
            <span className="w-1 h-1 rounded-full bg-[#F9F8F6]/40 flex-shrink-0" />
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default MarqueeSection;
